import { roleRestricted, AD, SA } from '../components/RoleRestricted/utils';
import { PartOfCrp } from '../models/project';

export const isPartOfCrpPlan = (partOfCrp?: PartOfCrp[]): boolean =>
  Array.isArray(partOfCrp) && partOfCrp.length > 0;

export const isPartOfApprovedCrp = (partOfCrp?: PartOfCrp[]): boolean =>
  isPartOfCrpPlan(partOfCrp) && partOfCrp.some((item) => item.approved);

export const shouldAutoPromoteToDraft = (
  projectStatus: string,
  partOfCrp: PartOfCrp[] | undefined,
  projectSource: string | undefined,
): boolean =>
  !projectFromReltp(projectSource) &&
  isPartOfCrpPlan(partOfCrp) &&
  (projectStatus === 'QUALIFIED' || projectStatus === 'UNQUALIFIED');

const fieldsLockedOnIsep = ['programmeName', 'solutions'];
const unitTypeFields = ['unitCategory', 'unitType'];
const fieldsLockedForSisan = [
  'country',
  'address',
  'locationName',
  'city',
  'transactionType',
];
const fieldsLockedForSisanAndClosed = ['businessUnitId'];
const siteFields = [
  'transactionType',
  'countryCode',
  'city',
  'state',
  'address',
  'locationName',
  'transactionType',
];

const allFields = [
  'ALL',
  ...fieldsLockedForSisanAndClosed,
  ...fieldsLockedOnIsep,
  ...fieldsLockedForSisan,
  ...siteFields,
  ...unitTypeFields,
  'etrProjectPrioritization',
  'countryProjectResponsible',
  'approvedBudget',
  'totals',
  'unifierId',
  'buttons',
  'projectOrderer',
];

export const projectFromReltp = (projectSource) =>
  ['RELTP', 'RELTP_ETR1', 'RELTP_ETR2'].includes(projectSource);
export const returnLockedFields = (
  projectSource,
  isep,
  establishmentType,
  role,
  category,
  disableRestrictions,
  readOnly = false,
) => {
  if (readOnly) return allFields;
  const fields = [];
  if (projectFromReltp(projectSource)) {
    fields.push('ALL', ...siteFields);
    if (!roleRestricted([AD, SA], role))
      fields.push('etrProjectPrioritization');
    if (!!category) fields.push(...unitTypeFields);
    return fields;
  }
  if (roleRestricted([SA], role)) return [];
  if (disableRestrictions) return [];
  if (!isep) return [];
  fields.push(...fieldsLockedOnIsep, ...siteFields);
  if (category) fields.push(...unitTypeFields);
  if (establishmentType === 'SISAN') {
    fields.push(...fieldsLockedForSisan, ...fieldsLockedForSisanAndClosed);
  }
  if (establishmentType === 'CLOSED') {
    fields.push(...fieldsLockedForSisanAndClosed);
  }
  return fields;
};

export const returnDisabledStatus = (
  disabledFields,
  field,
  disableOnAll = true,
) => {
  if (disableOnAll && disabledFields.includes('ALL')) return true;
  return disabledFields.includes(field);
};
